import angular from 'angular';
import ChargecodeTableComponent from './chargecode-table.component';

let ChargecodeTableModule = angular.module('chargecodeTable', [])

.config(($stateProvider, $urlRouterProvider) => {
  "ngInject";
})

.component('chargecodeTable', ChargecodeTableComponent);

export default ChargecodeTableModule;



// WEBPACK FOOTER //
// ./client/pages/admin/employee-create/components/chargecode-table/chargecode-table.js